import React, { PureComponent } from 'react';

import { enumHelper } from '../../../utils';
import ENUMS from '../../../enums';

import CafeDiscountDetails from '../modals/cafeDiscountDetails';

import styles from './styles.scss';

class ListItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedCafeDiscountDetailsId: -1
    };
  }

  convertStatusToBadge = status => {
    switch (status) {
      case ENUMS.CAFE_DISCOUNT_STATUS.values.CONFIRMED:
        return 'badge-success';
      case ENUMS.CAFE_DISCOUNT_STATUS.values.REJECTED:
        return 'badge-danger';
      case ENUMS.CAFE_DISCOUNT_STATUS.values.REQUESTED:
        return 'badge-warning';
      default:
        return '';
    }
  };

  closeCafeDiscountDetailsModal = () => {
    this.setState(() => ({
      cafeDiscountDetailsOpen: false
    }));
  };

  displayCafeDiscountDetailsModal = id => {
    this.setState({ cafeDiscountDetailsOpen: true, selectedCafeDiscountDetailsId: id });
  };

  render() {
    return (
      <>
        <tr>
          <td className="text-center">
            {(this.props.pageNumber - 1) * this.props.pageSize + this.props.ix + 1}
          </td>
          <td className="text-center">{this.props.fromDate}</td>
          <td className="text-center">{this.props.toDate}</td>
          <td className="text-center">
            <span className={`badge ${this.convertStatusToBadge(this.props.status)} p-1`}>
              {enumHelper.convertEnumValueToTitle(ENUMS.CAFE_DISCOUNT_STATUS.list, this.props.status)}
            </span>
          </td>
          <td className={styles.createdAtColValue}>{this.props.createdAt}</td>
          <td title={locales('titles.cafeDiscountDetails')} className="text-center">
            <i
              onClick={() => this.displayCafeDiscountDetailsModal(this.props.id)}
              className="pointer far fa-info-circle"
            />
          </td>
        </tr>
        {this.state.cafeDiscountDetailsOpen && (
          <CafeDiscountDetails
            isOpen={this.state.cafeDiscountDetailsOpen}
            discountId={this.state.selectedCafeDiscountDetailsId}
            closeModal={this.closeCafeDiscountDetailsModal}
          />
        )}
      </>
    );
  }
}

export default ListItem;
